<template>
  <path fill="#fbbb00" d="M14.5 39.6 12.2 48l-8.3.2a32.8 32.8 0 0 1-.2-30.6L11 19l3.2 7.4a19.5 19.5 0 0 0 .2 13.2Z"/>
  <path fill="#518ef8" d="M65 26.6a32.7 32.7 0 0 1-11.8 31.7l-9.3-.5-1.3-8.3a19.5 19.5 0 0 0 8.4-10H33.5V26.7h31.4Z"/>
  <path fill="#28b446" d="M53.2 58.3A32.8 32.8 0 0 1 4 48.3l10.6-8.7a19.5 19.5 0 0 0 28 10Z"/>
  <path fill="#f14336" d="M53.6 7.5 43 16.2a19.5 19.5 0 0 0-28.7 10.2L3.7 17.7a32.7 32.7 0 0 1 50-10.2Z"/>
</template>
